import { useTranslation } from 'react-i18next';
import { LanguageIcon } from '@heroicons/react/24/outline';
import clsx from 'clsx';

const languages = [
  { code: 'en', name: 'English' },
  { code: 'es', name: 'Español' },
];

export function LanguageSwitcher() {
  const { i18n, t } = useTranslation();

  const handleChange = (code: string) => {
    i18n.changeLanguage(code);
  };

  return (
    <div className="px-3 py-2">
      <div className="flex items-center gap-2 text-sm text-gray-500 dark:text-slate-400 mb-2">
        <LanguageIcon className="h-4 w-4" />
        <span>{t('language.title')}</span>
      </div>
      <div className="flex gap-2">
        {languages.map((lang) => (
          <button
            key={lang.code}
            onClick={() => handleChange(lang.code)}
            className={clsx(
              'flex-1 px-3 py-1.5 text-sm rounded-lg transition-colors',
              lang.code === i18n.language
                ? 'bg-primary-100 dark:bg-primary-900/30 text-primary-700 dark:text-primary-400 font-medium'
                : 'text-gray-600 dark:text-slate-300 hover:bg-gray-100 dark:hover:bg-slate-700'
            )}
          >
            {lang.name}
          </button>
        ))}
      </div>
    </div>
  );
}
